import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import ServicePage from "./pages/ServicePage";
import ContactPage from "./pages/ContactPage";
import Updates from "./pages/Updates";
import PricingPage from "./pages/PricingPage";
import PaymentsPage from "./pages/PaymentsPage";
import ScrollToTop from "./components/ScrollToTop";
import LocationsPage from "./pages/LocationsPage";

function App() {
  return (
    <>
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/locations" element={<LocationsPage />} />
        <Route path="/updates" element={<Updates />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/payments" element={<PaymentsPage />} />
      </Routes>
    </>
  );
}

export default App;
